export default __webpack_public_path__ + "static/media/icn-cruise-control-time.ae0d1664.svg";